import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          <div>
            <img 
              src="https://public.readdy.ai/ai/img_res/ea71a4d4baa0bd72151336fd55e732d3.jpg" 
              alt="アシーブメント UFB DUAL" 
              className="h-12 w-auto mb-4"
            />
            <p className="text-sm text-gray-400">
              ウルトラファインバブル水を住宅全体で使える水道機器
            </p>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-4">製品情報</h3>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><a href="#about" className="hover:text-white transition-colors">製品について</a></li>
              <li><a href="#technology" className="hover:text-white transition-colors">UFB水の特徴</a></li>
              <li><a href="#voice" className="hover:text-white transition-colors">導入事例</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-4">サポート</h3>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><a href="#steps" className="hover:text-white transition-colors">ご依頼の流れ</a></li>
              <li><a href="#faq" className="hover:text-white transition-colors">よくあるご質問</a></li>
              <li><a href="#contact" className="hover:text-white transition-colors">お問い合わせ</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-4">会社情報</h3>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>アシーブメント</li>
              <li>〒594-0071<br />大阪府和泉市府中町6丁目14-42</li>
              <li>
                <a href="mailto:acm01tsubo@gmail.com" className="hover:text-white transition-colors">
                  acm01tsubo@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-sm text-gray-400 mb-4 md:mb-0">
              © 2025 アシーブメント All Rights Reserved.
            </p>
            <div className="flex items-center space-x-4">
              <a 
                href="https://readdy.ai/?origin=logo" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-sm text-gray-400 hover:text-white transition-colors"
              >
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
